"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _vuexClass = require("vuex-class");
var SingleImage = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(SingleImage, _Vue);
  var _super = (0, _createSuper2.default)(SingleImage);
  function SingleImage() {
    var _this;
    (0, _classCallCheck2.default)(this, SingleImage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "imagePath", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploadUrl", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "width", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "height", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "disabled", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "token", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isProgressing", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "percentUpload", 0);
    return _this;
  }
  (0, _createClass2.default)(SingleImage, [{
    key: "onSuccess",
    value: function onSuccess(url) {
      return url;
    }
  }, {
    key: "onProgress",
    value: function onProgress(event, file, fileList) {
      this.isProgressing = true;
      this.percentUpload = parseInt(event.percent.toFixed(0));
    }
  }, {
    key: "onError",
    value: function onError(err, file, fileList) {
      if (err.message) {
        this.$message.error(err.message);
      }
      this.isProgressing = false;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(res) {
      this.onSuccess(res.data.path);
      this.isProgressing = false;
    }
  }, {
    key: "beforeUpload",
    value: function beforeUpload(file) {
      var isJPG = file.type.includes("image");
      if (!isJPG) {
        this.$message.error("Image is not valid format!");
      }
      return isJPG;
    }
  }]);
  return SingleImage;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String
})], SingleImage.prototype, "imagePath", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: "/v1/admin/media/upload",
  type: String
})], SingleImage.prototype, "uploadUrl", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 360
})], SingleImage.prototype, "width", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 180
})], SingleImage.prototype, "height", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], SingleImage.prototype, "disabled", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)("user/token")], SingleImage.prototype, "token", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("success")], SingleImage.prototype, "onSuccess", null);
SingleImage = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], SingleImage);
var _default = SingleImage;
exports.default = _default;